import type {
  IconProp,
  IconDefinition,
  SizeProp,
} from '@fortawesome/fontawesome-svg-core'
import { VariantProps } from 'class-variance-authority'
import {
  FontAwesomeIcon,
  FontAwesomeIconProps,
} from '@fortawesome/react-fontawesome'

import { mtc } from '../../../utils/style-helpers'
import { backgroundStyles } from './styles'

export interface IconProps extends Omit<FontAwesomeIconProps, 'icon'> {
  /** The background color of the icon */
  backgroundColor?: VariantProps<typeof backgroundStyles>['backgroundColor']
  /** The shape of the background */
  backgroundStyle?: 'circle' | 'rounded'
  backgroundClassName?: string
  /** Icon color - Use Tailwind utility class names with text-* prefix */
  color?: string // will need to come back to this and be more explicit
  /** Icon to display - can be an IconDefinition or a FontAwesome icon object */
  icon: IconProp | IconDefinition
  /** Font Awesome supports t-shirt size scale from 2xs to 10x as well as literal sizing from 1x to 10x */
  size?: SizeProp
  /** Variant of the icon */
  variant?: 'checkbox'
}

/** Icon component that wraps FontAwesomeIcon */
export const Icon = ({
  backgroundColor,
  backgroundStyle,
  className,
  backgroundClassName,
  color = 'text-neutral-600',
  icon,
  size,
  variant,
  ...props
}: IconProps) => {
  return (
    <span
      className={mtc(
        backgroundStyles({ backgroundStyle, size, backgroundColor, variant }),
        backgroundClassName
      )}
    >
      <FontAwesomeIcon
        className={mtc(`${className} ${color} w-full h-full`)}
        icon={icon}
        size={size}
        {...props}
      />
    </span>
  )
}

Icon.displayName = 'Icon'
